import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import LiveTracker from '@/pages/home/components/LiveTracker';
import TrendingStories from '@/pages/home/components/TrendingStories';
import TopicExplorer from '@/pages/home/components/TopicExplorer';
import StoryTimeline from '@/pages/home/components/StoryTimeline';
import FaqSection from '@/pages/home/components/FaqSection';
import AboutSection from '@/pages/home/components/AboutSection';
import ContactFooter from '@/pages/home/components/ContactFooter';
import BackToTop from '@/pages/home/components/BackToTop';
import { faqs } from '@/mocks/site';
import { stories } from '@/mocks/stories';

const SITE_URL = 'https://locat.cn/';

const structuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: '瓜田情报局',
      url: SITE_URL,
      inLanguage: 'zh-CN',
      description:
        '追踪网络热议大瓜的后续进展，实时汇总最新回应、剧情反转、当事人发声与第二弹更新。',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${SITE_URL}?s={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '瓜田情报局',
      url: SITE_URL,
      email: 'tips@guatian-informant.cn',
      description: '专注热点事件后续进展整理与追踪的内容站点，只梳理、不生产未经核实的信息。',
      contactPoint: [
        {
          '@type': 'ContactPoint',
          contactType: 'editorial',
          email: 'tips@guatian-informant.cn',
          availableLanguage: 'zh-CN',
        },
      ],
    },
    {
      '@type': 'WebPage',
      name: '黑料大瓜后续进展最新回应与反转追踪',
      description:
        '大瓜后续进展实时跟进，最新回应、剧情反转、当事人发声、第二弹持续更新，一个瓜从爆出到尘埃落定全程追踪。',
      url: SITE_URL,
      inLanguage: 'zh-CN',
      isPartOf: { '@type': 'WebSite', url: SITE_URL },
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: '热点追踪', item: `${SITE_URL}#live` },
        { '@type': 'ListItem', position: 3, name: '黑料大瓜后续进展', item: `${SITE_URL}#trending` },
      ],
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqs.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    },
    {
      '@type': 'ItemList',
      name: '今日大瓜追踪列表',
      itemListElement: stories.map((story, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: story.title,
        url: `${SITE_URL}#trending`,
      })),
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <Navbar />
      <main className="w-full">
        <Hero />

        <nav aria-label="面包屑" className="w-full border-b border-background-200 bg-background-50">
          <div className="mx-auto flex w-full max-w-6xl flex-wrap items-center gap-1.5 px-4 py-3 text-xs text-foreground-500 md:px-6">
            <a href="#top" className="transition-colors hover:text-primary-600">
              首页
            </a>
            <i className="ri-arrow-right-s-line" />
            <a href="#live" className="transition-colors hover:text-primary-600">
              热点追踪
            </a>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-800">黑料大瓜后续进展</span>
          </div>
        </nav>

        <LiveTracker />
        <TrendingStories />
        <TopicExplorer />
        <StoryTimeline />
        <FaqSection />
        <AboutSection />
      </main>
      <ContactFooter />
      <BackToTop />
    </div>
  );
}